import type { SubmitResult } from '../../api/types';
import type { DiceRollRequest } from '../../tabs/contract';

/**
 * 提出の結果から、ダイスの演出に渡す値を作る（表示用。値はすべてサーバーが決めたもの）。
 * 基礎点は結果に入っていないので、スポットの base_point を渡す。無ければ得点を倍率で割り戻す。
 * スポットの初クリア以外（dice_value が無い）は null。
 */
export function diceRequestFrom(result: SubmitResult, basePoint: number | null, title?: string): DiceRollRequest | null {
  if (result.dice_value == null) return null;
  const d = result.dice_multiplier ?? 1;
  const a = result.area_multiplier ?? 1;
  const e = result.effect_multiplier ?? 1;
  const base = basePoint ?? Math.round(result.earned_score / Math.max(0.0001, d * a * e));
  return {
    value: result.dice_value,
    ...(title ? { title } : {}),
    baseScore: base,
    diceMultiplier: d,
    areaMultiplier: a,
    effectMultiplier: e,
    earnedScore: result.earned_score,
    teamTotal: result.team_total,
  };
}
